import { Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { StateService } from '@uirouter/angular';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-pre-check-product',
  templateUrl: './pre-check-product.component.html',
  styleUrls: ['./pre-check-product.component.scss']
})
export class PreCheckProductComponent implements OnInit {

  @ViewChild("infoPanel") infoPanel;

  user_id = {'user_id': this.dataService.userDetails['user_id']};
  preCheckForm = {};
  productArray = [];
  preCheckResponse = '';
  loading = false;

  constructor(
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private stateService: StateService,
    private modalService: NgbModal,
    private logService: LogService
  ) { }

  ngOnInit() {
  }


  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  typepreCheckProduct() {
    this.preCheckForm['user_id'] = this.dataService.userDetails['user_id'];
    this.preCheckResponse = this.preCheckForm['oid'];
    this.loading = true;
    this.apiService.preCheck(this.preCheckForm, (response) => {
      // this.logService.printLog("product form response -", this.productForm);
      // this.logService.printLog("verify product response-", response);
      response.oid = this.preCheckResponse;
      console.log("precheck response", response);
      this.productArray.unshift(response);
      // this.logService.printLog("product Form -", this.productArray);
      this.loading = false;
      this.preCheckForm["oid"] = "";
      this.infoPanel.getProductData();
      this.infoPanel.isProduct = true;
    });
  }

  codeDetected(event) {
    this.logService.printLog('scan code', event);
    this.preCheckForm['ean'] = event.toUpperCase();
    this.typepreCheckProduct();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/pre-check-product/pre-check-product.component.ts